@use "../../../styles/breakpoint.module.scss" as *;

.screen {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    text-align: center;
}

.body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-block: var(--spacer-40);
}

.eyebrow {
    margin-bottom: var(--spacer-8);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.prompt {
    margin-bottom: var(--spacer-40);
    font: var(--font-h-40);
}

.optionsGrid {
    /* Track width = whatever a 3-column row would shrink each tile to
     * at this container width (capped at the design's 412 max). 1- and
     * 2-tile rows use the same size as 3-tile rows so tiles never look
     * fatter just because there are fewer of them. */
    --tile-max: min(412px, calc((100% - 2 * var(--labui-grid-gap)) / 3));
    --margin: var(--spacer-80);

    composes: listReset from "../../../styles/composable/utility.module.css";
    display: grid;
    grid-template-columns: repeat(
        var(--columns, 3),
        minmax(0, var(--tile-max))
    );
    justify-content: center;
    gap: var(--labui-grid-gap);
    margin-left: max(var(--margin), env(safe-area-inset-left));
    margin-right: max(var(--margin), env(safe-area-inset-right));

    @media ($above-mobile) {
        // Center a lone last item in the final row when there are 3 columns
        > *:nth-child(n + 4):last-child:nth-child(3n + 1) {
            grid-column-start: 2;
        }
    }

    @media ($below-mobile) {
        --margin: var(--labui-container-margin);

        grid-template-columns: 1fr;
    }
}
